<template>
  <button
    ref="card"
    class="rounded-lg flex h-[108px] w-[223px]"
    @click="onClick"
  >
    <div class="rounded-lg flex flex-col justify-start gap-0 px-24 py-24 pb-12">
      <component :is="getIconComponent(checkpoint.icon)" size="32" />
      <p
        class="text-action-default-hi body-2-bold line-clamp-2 text-ellipsis break-all text-left"
        :title="text"
      >
        {{ text }}
      </p>
    </div>
  </button>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, useTemplateRef } from 'vue'

import type { AnimatedProductCheckpoint } from '@backmarket/nuxt-layer-cms/BaseAnimatedProductCheckpoints/categories'
import { getIconComponent } from '@backmarket/nuxt-layer-cms/BaseAnimatedProductCheckpoints/utils'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { openModal } from '@ds/components/ModalBase'
import { useIntersectionObserver } from '@vueuse/core'

import { MODAL_NAMES } from '~/scopes/product/constants'

const props = defineProps<{
  checkpoint: AnimatedProductCheckpoint
  index: number
}>()

const i18n = useI18n()
const { trackClick, trackCarouselImpression } = useTracking()

const observer = ref<ReturnType<typeof useIntersectionObserver>>()
const card = useTemplateRef<HTMLDivElement>('card')

const text = i18n(props.checkpoint.text)

function onClick() {
  openModal(MODAL_NAMES.VERIFIED_REFURBISHED)
  trackClick({
    zone: 'verified_refurbished_carousel',
    value: text,
  })
}

onMounted(() => {
  observer.value = useIntersectionObserver(
    card.value,
    ([{ isIntersecting }]) => {
      if (isIntersecting) {
        trackCarouselImpression({
          name: 'carousel_interaction',
          zone: 'verified_refurbished_carousel',
          blockPosition: props.index,
          currentSlide: props.index,
          value: text,
          trackFirstIndex: true,
        })
      }
    },
    {
      threshold: [0.5],
    },
  )
})

onBeforeUnmount(() => {
  if (observer.value) {
    observer.value?.stop()
  }
})
</script>
